<template>
    <component
      :is="`${sticker.type}Sticker`"
      v-bind="{ ...sticker, ...sticker.data }"
      :isEditing="!previewEnabled && sticker.isEditing"
      :isPreventCover="!previewEnabled && isPreventCover"
      :isCover="!previewEnabled && isCover"
      :setCover="setCover"
      :setCbClick="setCbClick"
      :files="files"
      :backgroundFileId="backgroundFileId"
      :pageSelected="pageSelected"
      :mutedSound="sticker.type === 'post' ? mutedSound : undefined"
      @updateSticker="updateSticker"
      @deleteSticker="deleteSticker"
    />
  </template>
  
  <script>

  import surveySticker from './survey.vue';
  import sliderSticker from './slider.vue';
  import mentionSticker from './mention.vue';
  import localisationSticker from './localisation.vue';
  import hashtagSticker from './hashtag.vue';
  import linkSticker from './link.vue';
  import productSticker from './product.vue';
  import imageSticker from './image.vue';
  import gifSticker from './gif.vue';
  import musicSticker from './music.vue';
  import musicMissingSticker from './musicMissing.vue';
  import textSticker from './text.vue';
  import postSticker from './post.vue';
  import questionSticker from './question.vue';
  import countdownSticker from './countdown.vue';
  export default {
    components: {
        surveySticker,
        sliderSticker,
        mentionSticker,
        localisationSticker,
        productSticker,
        imageSticker,
        gifSticker,
        hashtagSticker,
        linkSticker,
        musicSticker,
        musicMissingSticker,
        textSticker,
        postSticker,
        questionSticker,
        countdownSticker

    },
    props: {
      sticker: {
        type: Object,
        required: true
      },
      isPreventCover: {
        type: Boolean,
        required: false
      },
      isCover: {
        type: Boolean,
        required: false
      },
      setCover: Function,
      setCbClick: Function,
      files:Object,
      pageSelected: Object,
      previewEnabled: Boolean,
      backgroundFileId: String,
      mutedSound: {
        type: Boolean,
        default: true
      },
    },

    mounted () {
        if(this.sticker.isEditing && !this.isCover && !this.isPreventCover && !this.previewEnabled) {
            console.log('setCover mounted');
            this.setCover(true)
        }
    },
 
    methods: {
      updateSticker(id,payload) {
        this.$emit('updateSticker', id, payload);
      },
      deleteSticker(id) {
        this.$emit('deleteSticker', id);
      }
    },
  };
  </script>
  